import React, { useEffect, useReducer, useRef, useState } from 'react'
import { makeRequest } from '../../js/utils/makeRequest'
import { serialize } from '../../js/utils/serialize'
import { reducer, initialReducerState } from './reducers'
import Form from './components/Form'
import FilterSelect from './components/FilterSelect'
import LineChartBlock from './components/LineChartBlock'
import CurrencyTable from './components/CurrencyTable'
import { useMutation } from 'react-query'
import { AppContext, formId, queryId } from './constants'
import Loader from './components/Loader'

/**
 * @param currencyFilterItems{Object=} - cfg для фильтра по валюте
 * @param periodFilterItems{Array[Object]} - cfg для фильтра по периоду
 * @param requestCfg{Object=} - cfg для запроса данных
*/

const App = ({ currencyFilterItems, periodFilterItems, requestCfg }) => {
  const [state, dispatch] = useReducer(reducer, initialReducerState)
  const { url } = requestCfg
  const formRef = useRef(null)
  const [periodFilters, setPeriodFilters] = useState(periodFilterItems)

  const { mutateAsync: updateChartData, isLoading } = useMutation({
    mutationFn: () => makeRequest({
      url: url + (url.indexOf('?') > -1 ? '&' : '?') + serialize(formRef.current),
      method: 'GET'
    }),
    mutationKey: queryId
  })

  const handleRadioChange = (e) => {
    const { target } = e
    const { value } = target
    setPeriodFilters(periodFilters => {
      return periodFilters.map(periodFilter => {
        return {
          ...periodFilter,
          radio: {
            ...periodFilter.radio,
            isChecked: periodFilter.radio.value === value
          }
        }
      })
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    dispatch({ type: 'filterData', payload: new FormData(formRef.current) })
  }

  const onSuccess = (response) => {
    const { chartData, todayData, tableData } = response.data
    dispatch({ type: 'chartData', payload: chartData })
    dispatch({ type: 'todayData', payload: todayData })
    dispatch({ type: 'tableData', payload: tableData })
  }

  const onError = (error) => {
    console.error('Filter error: ', error)
  }

  useEffect(() => {
    dispatch({ type: 'filterData', payload: new FormData(formRef.current) })
  }, [])

  useEffect(() => {
    if (Array.from(state.filterData.keys()).length) {
      updateChartData()
        .then((response) => {
          if (response.isSuccess) {
            onSuccess(response)
          } else {
            onError(response.data.error)
          }
        })
        .catch((err) => onError(err))
    }
  }, [state.filterData])

  return (
    <AppContext.Provider value={{ formId, handleFormSubmit, handleRadioChange, formRef, dispatch, state }}>
      <div className='currency-chart__wrapper'>
        <Form ref={formRef} />
        <FilterSelect {...{ ...currencyFilterItems.select, size: 'big' }} />
        <LineChartBlock {...{ periodFilters, isLoading, state }} />
        <>
          {isLoading && <Loader />}
          {!isLoading && state.tableData && <CurrencyTable {...state.tableData} />}
        </>
      </div>
    </AppContext.Provider>
  )
}

export default App
